import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  { 
    path: '', 
    redirectTo: '/admin', 
    pathMatch: 'full' 
  },
  { 
    path: 'auth', 
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule) 
  },
  { 
    path: 'admin',
    loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [authGuard, roleGuard([1, 2, 3])] // Admin, Usuario y Super Admin pueden acceder
  },
  { 
    path: 'admin/ticket',
    loadChildren: () => import('./features/tickets/tickets.module').then(m => m.TicketsModule),
    canActivate: [authGuard, roleGuard([1, 2, 3])] // Admin, Usuario y Super Admin pueden acceder
  },
  { 
    path: 'admin/users',
    loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule),
    canActivate: [authGuard, roleGuard([3])] // Solo Super Admin puede acceder
  },
  { 
    path: 'admin/colaborators',
    loadChildren: () => import('./features/colaborators/colaborators.module').then(m => m.ColaboratorModule),
    canActivate: [authGuard, roleGuard([1, 3])] // Admin y Super Admin pueden acceder
  },
  { 
    path: 'admin/configuration',
    loadChildren: () => import('./features/configuration/configuration.module').then(m => m.ConfigurationModule),
    canActivate: [authGuard, roleGuard([3])] // Solo Super Admin puede acceder
  },
  
  // Rutas legacy (mantener por compatibilidad)
  { 
    path: 'users', 
    loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule), 
    canActivate: [authGuard, roleGuard([3])] // Solo Super Admin
  },
  { 
    path: 'tickets', 
    loadChildren: () => import('./features/tickets/tickets.module').then(m => m.TicketsModule), 
    canActivate: [authGuard, roleGuard([1, 2, 3])] // Todos los roles autenticados
  },
  
  { path: '**', redirectTo: '/admin' }
];
